export const CREDIT_USAGE = {
    Reading: 10,
    Writing: 5,
    Vocabulary: 15,
    Listening: 20,
};